import {auth} from '@common/auth/use-auth';
import {billingQueries} from '@common/billing/billing-queries';
import {queryClient} from '@common/http/query-client';
import {redirect, RouteObject} from 'react-router';
import {billingRouteNames} from './billing-route-names';

export const billingPageChildRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () => import('@common/billing/billing-page/billing-page'),
    handle: {billingRouteName: billingRouteNames.billing},
  },
  {
    path: 'change-payment-method',
    lazy: () =>
      import('@common/billing/billing-page/change-payment-method/change-payment-method-layout'),
    loader: () => queryClient.ensureQueryData(billingQueries.products.index()),
    children: [
      {
        index: true,
        lazy: () =>
          import('@common/billing/billing-page/change-payment-method/change-payment-method-page'),
        handle: {billingRouteName: billingRouteNames.changePaymentMethod},
      },
      {
        path: 'done',
        lazy: () =>
          import('@common/billing/billing-page/change-payment-method/change-payment-method-done'),
        handle: {billingRouteName: billingRouteNames.changePaymentMethodDone},
      },
    ],
  },
  {
    path: 'change-plan',
    lazy: () => import('@common/billing/billing-page/change-plan-page'),
    loader: () => queryClient.ensureQueryData(billingQueries.products.index()),
    handle: {billingRouteName: billingRouteNames.changePlan},
  },
  {
    path: 'change-plan/:productId/:priceId/confirm',
    lazy: () => import('@common/billing/billing-page/confirm-plan-change-page'),
    handle: {billingRouteName: billingRouteNames.confirmPlanChange},
  },
  {
    path: 'cancel',
    lazy: () =>
      import('@common/billing/billing-page/confirm-plan-cancellation-page'),
    handle: {billingRouteName: billingRouteNames.cancelPlan},
  },
  {
    path: 'renew',
    lazy: () =>
      import('@common/billing/billing-page/confirm-plan-renewal-page'),
    handle: {billingRouteName: billingRouteNames.renewPlan},
  },
];

export const billingPageRoutes: RouteObject[] = [
  {
    path: 'pricing',
    lazy: () => import('@common/billing/pricing-table/pricing-page'),
    loader: () =>
      queryClient.ensureQueryData(billingQueries.products.index('pricingPage')),
  },
  {
    path: 'billing',
    loader: () => {
      if (!auth.isSubscribed) {
        return redirect('/pricing');
      }
      return queryClient.ensureQueryData(billingQueries.user());
    },
    lazy: () => import('@common/billing/billing-page/billing-page-layout'),
    children: billingPageChildRoutes,
  },
];
